















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxLookup } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel } from 'devextreme-vue/form';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import quotationsRepository from '@/services/quotationsRepository';
import { AssignedContact, ContactBasicInformation } from '@/data/web-api-client';

@Component({
  components: {
    DxPopup,
    DxLookup,
    DxSimpleItem,
    DxGroupItem,
    DxForm,
    DxLabel,
    DxItem,
    DxToolbarItem,
    DxRequiredRule,
    Popup,
  },
})
export default class QuotationGenerationDialog extends Vue {
  public saving: boolean = false;
  public loading: boolean = false;
  public quoteGenerationModel: any = {
    projectId: null,
    measurementNames: null,
    quotationId: null,
    contactId: null,
  };

  @Prop({ required: true, default: false })
  public show?: boolean;

  @Prop({ required: true, default: [] })
  public quotations?: any[];

  @Prop({ required: false, default: [] })
  public contacts?: ContactBasicInformation[];

  @Prop({ required: true, default: [] })
  public measurements?: any[];

  public hideDialog() {
    this.$emit('hide');
  }

  get title() {
    return this.$t('objects.quotations.GenerateTitle');
  }

  get form() {
    const form: any = this.$refs.quoteGenerationForm;
    return form.instance;
  }

  get quotationsOptions() {
    const self = this;
    return {
      dataSource: self.quotations,
      valueExpr: 'id',
      displayExpr: 'documentNumber',
      searchEnabled: true,
      showClearButton: true,
      showCancelButton: true,
    };
  }

  get contactsOptions() {
    if (this.contacts && this.contacts.length > 0) {
      this.quoteGenerationModel.contactId = this.contacts[0].id;
    }

    const self = this;
    return {
      dataSource: self.contacts,
      valueExpr: 'id',
      displayExpr: 'displayName',
      searchEnabled: true,
      showClearButton: true,
      showCancelButton: true,
    };
  }

  get measurementsOptions() {
    const self = this;
    return {
      dataSource: self.measurements,
      valueExpr: 'name',
      displayExpr: 'name',
    };
  }

  public async save() {
    try {
      const validationResult = this.form.validate();
      if (validationResult.isValid) {
        this.saving = true;
        const result = await quotationsRepository.generate(this.quoteGenerationModel);
        this.$router.push({ path: `/quotations/${result.data.id}` });
        notificationService.saved();
        this.$emit('saved');
        this.hideDialog();
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }
}
